import { HOUR_IN_MILLISECONDS } from 'config';
import { ProjectDto, useProjectQuery } from 'providers/api';
import { UseQueryResult } from 'react-query';
import { CustomReportTemplatesPageParams } from './constants';

export type CustomReportTemplatesPageQueries = [
  UseQueryResult<ProjectDto>,
];

const useCustomReportTemplatesPageQueries = (params: CustomReportTemplatesPageParams): CustomReportTemplatesPageQueries => [
  useProjectQuery(params.projectId, {
    staleTime: HOUR_IN_MILLISECONDS,
  }),
];

export default useCustomReportTemplatesPageQueries;
